/**
 * Observer 브랜드 글리프 (#98)
 * --------------------------------------------------------------------------
 * 모양의 원본은 `design-system/components/brand-icons`입니다. 두 글리프는 한 가족이라
 * 한쪽을 바꾸면 다른 쪽과 favicon(`public/favicon.svg`)도 함께 봅니다.
 * 둘 다 장식이므로 aria-hidden입니다 — 이름은 감싸는 요소(브랜드 텍스트·버튼 aria-label)가 가집니다.
 */

/** 초점이 옮겨간 O — 헤더 브랜드 마크. `.ds-brand-mark` 배지 안에 둡니다. */
export function ObserverGlyph() {
  return (
    <svg className="ds-glyph" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path
        fillRule="evenodd"
        d="M16 3.5a12.5 12.5 0 1 1 0 25 12.5 12.5 0 0 1 0-25Zm2.6 7a7.4 7.4 0 1 0 0 14.8 7.4 7.4 0 0 0 0-14.8Z"
      />
      <circle cx="21.2" cy="20.4" r="2.7" />
    </svg>
  );
}

/** 말하는 O — 진단 버튼 글리프. */
export function DiagnoseGlyph() {
  return (
    <svg className="ds-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fillRule="evenodd"
        d="M12.5 2.5a8.5 8.5 0 1 1-4.6 15.65L3 21l1.6-5.2A8.5 8.5 0 0 1 12.5 2.5Zm1.4 4.1a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2Z"
      />
      <circle cx="15.9" cy="13.6" r="1.8" />
    </svg>
  );
}
